import React, { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

const NumberTicker = ({ value, className, prefix = "" }) => {
  const spring = useSpring(value, { mass: 0.8, stiffness: 75, damping: 15 });
  const display = useTransform(spring, (current) => Math.round(current).toLocaleString());

  useEffect(() => {
    spring.set(value);
  }, [value, spring]);

  return (
    <motion.span className={className}>
      {prefix}<motion.span>{display}</motion.span>
    </motion.span>
  );
};

export default NumberTicker;